angular.module("dx.webapp.suggestionDropdown", []);
